import React, { useCallback, useEffect } from 'react';
import Input from '../../../forms/Input';
import { makeField, PostProcessor } from 'nike-form-js';
import { FREETEXT } from './validators';

function KycQuestionFreeText({ form, question }) {
    if (!question) {
        return null;
    }

    return (
        <>
            <h1 className="kyc-list-title mt-20 mb-15 fs-16 text-extra-bold">{question.label}</h1>
            {question.option.map(option => (
                <FreeText key={option.id} form={form} question={question} option={option} />
            ))}
        </>
    );
}

function FreeText({ form, question, option }) {
    const path = [question.type, question.id, option.id, FREETEXT];
    const field = makeField(form, path);
    const isTouched = PostProcessor.isTouchedField(form.deref(), path);

    const initAndTouchFreeTextOnForm = useCallback(value => field.setValue(value), [field]);
    useEffect(() => {
        if (!isTouched) {
            initAndTouchFreeTextOnForm('');
        }
    }, [isTouched, initAndTouchFreeTextOnForm]);

    return (
        <Input
            key={option.id}
            type="textarea"
            form={form}
            id={'freetext' + option.id}
            name={'freetext'}
            path={path}
            placeholder={option.label}
            rows="3"
            className="nui-textarea"
            maxLength="250"
        />
    );
}

export default KycQuestionFreeText;
